import { SVGProps } from './types';

function ArrowNarrowRight(props: SVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#fff"
        strokeLinecap="square"
        strokeWidth="1.74"
        d="M3.333 10h13.334m0 0l-5-5m5 5l-5 5"
      />
    </svg>
  );
}

export { ArrowNarrowRight };
